const firebaseConfig = {
  apiKey: 'AIzaSyAtVD1M2p-Kcz6b2BLt4GnQ6rA0kzECsGo',
  authDomain: 'elsa-app-bd2f8.firebaseapp.com',
  databaseURL: 'https://elsa-app-bd2f8.firebaseio.com',
  projectId: 'elsa-app-bd2f8',
  storageBucket: 'elsa-app-bd2f8.appspot.com',
  messagingSenderId: '413683105247',
  appId: '1:413683105247:web:39ab970cb8a06f7ddf586a',
  measurementId: 'G-BYMTZ08V5D'
};

export default firebaseConfig;
